import { ChangeEvent } from "react";
import { Icon } from "assets/icons";

import { TextInput } from "components/TextInput/TextInput";

import styles from "./styles.module.scss";

type SimpleInputProps = {
  onChange: (ev: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value?: string;
};

export const SimpleInput = ({
  onChange,
  placeholder = "Поиск",
  value,
}: SimpleInputProps): JSX.Element => {
  return (
    <div className={styles.searchInput}>
      <TextInput
        onChange={onChange}
        className={styles.input}
        placeholder={placeholder}
        value={value}
      />
      <span className={styles.searchIcon}>
        <Icon type="search" size={16} />
      </span>
    </div>
  );
};
